import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import NavLogin from 'components/navbar/NavLogin'
import loadable from '@loadable/component'
import useSessionValidation from 'hooks/useSessionValidation'
import styles from './styles/NavButtons.css'
import classNames from 'classnames'
import OrganizationLogo from '../misc/OrganizationLogo'

import authButtonStyles from './styles/NavLogin.css'

const NavDropdown = loadable(() => import('components/navbar/NavDropdown'))

const AUTH_PATHS = ['/log-in', '/sign-up']

export const NavButtons = ({
  avatarBg = 'gray',
  buttonColor = 'transparent',
  staticPage,
  assistant = false,
  onMobileMenuClick
}) => {
  const user = useSelector(({ ui: { user } }) => user)
  const location = useLocation()
  const hideAuthButtons = AUTH_PATHS.includes(location.pathname)
  const navOpen = useSelector(({ ui: { navOpen } }) => navOpen)
  const [rendered, setRendered] = useState(false)
  const [renderOrgLogo, setRenderOrgLogo] = useState(false)

  useSessionValidation()

  useEffect(() => {
    setRendered(true)
  }, [])

  useEffect(() => {
    setRenderOrgLogo(!!user?.organizationLicense)
  }, [user])

  const toolsItems = [
    { name: 'Features', href: '/features' },
    { name: 'Integrations', href: '/integrations' },
    { name: 'Data', href: '/data' },
    { name: 'Rankings', href: '/ai-reads' },
    { name: 'Pricing', href: '/pricing' }
  ]

  return (
    <div className={styles.navButtons}>
      {rendered &&
        (onMobileMenuClick ? (
          <button className={styles.desktopHide} aria-label='Open menu' onClick={onMobileMenuClick}>
            <i className={styles.menuIcon} aria-hidden='true' />
          </button>
        ) : (
          <NavDropdown
            className={styles.desktopHide}
            buttonColor={buttonColor}
            initialShow={navOpen}
            dropdownClassName={styles.linkItem}
            items={toolsItems}
            menuOffset={[-45, 26]}
            organizationLogo={user?.organizationLicense}
          >
            <i className={styles.menuIcon} />
          </NavDropdown>
        ))}
      {renderOrgLogo && (
        <OrganizationLogo slug={user?.organizationLicense} styles={classNames(styles.orgLogo, styles.mobileHide)} />
      )}

      <NavLogin
        avatarBg={avatarBg}
        buttonColor={buttonColor}
        showSignup={staticPage}
        hideAuthButtons={hideAuthButtons}
        avatarWrapperMobile={authButtonStyles.showAvatarWrapper}
        signupClassName={authButtonStyles.hideDesktopButton}
        loginClassName={authButtonStyles.hideDesktopButton}
      />
    </div>
  )
}

export default NavButtons
